import { createSelector } from '@reduxjs/toolkit';
import { selectSplitSliceName } from '@socialive/common';

export default createSelector(
  (state) => state,
  selectSplitSliceName,
  (state, slice) => state[slice]
);
